const nav = document.querySelector("navigation");
const announcementBar = document.querySelector(".announcement-bar");
const allTriggers = document.querySelectorAll(".bosHeaderDropdowns");
const allDropdowns = document.querySelectorAll(".bosHeaderDropdown");
const navLinks = document.querySelectorAll(".bosHeaderNav > a");
const bosHeaderLogo = document.querySelector(".bosHeaderLogo");
const bosHeaderLogoInverse = document.querySelector(".bosHeaderLogoInverse");
const bosHeaderSvg = document.querySelectorAll(".bosHeaderSvg");

const bosHeaderText = document.querySelector(".bosHeaderText");
const bosHeaderTextInverse = document.querySelector(".bosHeaderTextInverse");

let activeDropdown = null;

// --- Announcement bar / nav top ---
function updateNavTop() {
  const barHeight = announcementBar ? announcementBar.offsetHeight : 0;
  nav.style.top = barHeight + "px";
}

// Set initial position instantly, without transition
nav.style.transition = "none";
updateNavTop();
// Force a reflow so the browser registers the position before re-enabling transition
nav.getBoundingClientRect();
nav.style.transition = "";

if (announcementBar) {
  const resizeObserver = new ResizeObserver(updateNavTop);
  resizeObserver.observe(announcementBar);
}

window.addEventListener("scroll", () => {
  const isStatic = nav.classList.contains("is-static");
  if (window.scrollY > 0) {
    if (announcementBar) announcementBar.style.display = "none";

    nav.style.top = "0px";
    nav?.classList.add("is-scrolled");

    // text
    bosHeaderText?.classList.add("hidden");
    bosHeaderTextInverse?.classList.remove("hidden");

  } else {
    if (announcementBar) announcementBar.style.display = "";
    updateNavTop();
    nav?.classList.remove("is-scrolled");

    // text
    bosHeaderText?.classList.remove("hidden");
    bosHeaderTextInverse?.classList.add("hidden");

    // logo
    bosHeaderLogoInverse?.classList.add("hidden");
    bosHeaderLogo?.classList.remove("hidden");
  }
});

// --- Dropdown open / close ---
function openDropdown(handle) {
  closeDropdown();
  const target = document.querySelector(
    `.bosHeaderDropdown[data-parent="${handle}"]`,
  );
  if (!target) return;
  activeDropdown = target;
  activeDropdown.classList.add("is-open");

  nav.classList.add("is-scrolled");
  const trigger = document.querySelector(
    `.bosHeaderDropdowns[data-current="${handle}"] .bosHeaderBtn`,
  );
  if (trigger) trigger.classList.add("is-scrolled-underline");
}
function closeDropdown() {
  if (!activeDropdown) return;
  activeDropdown.classList.remove("is-open");

  activeDropdown = null;
  if (window.scrollY === 0) {
    nav.classList.remove("is-scrolled");
  }
  document
    .querySelectorAll(".bosHeaderDropdowns .bosHeaderBtn")
    .forEach((b) => {
      b.classList.remove("is-scrolled-underline");
    });
}
allTriggers.forEach((trigger) => {
  trigger.addEventListener("mouseenter", () =>
    openDropdown(trigger.dataset.current),
  );
});
allDropdowns.forEach((drop) => {
  drop.addEventListener("mouseenter", () => openDropdown(drop.dataset.parent));
});
navLinks.forEach((link) => link.addEventListener("mouseenter", closeDropdown));
nav.addEventListener("mouseleave", closeDropdown);

// --- Align dropdown ul under its trigger button ---
function alignDropdown() {
  allTriggers.forEach((trigger) => {
    const btn = trigger.querySelector(".bosHeaderBtn");
    const drop = document.querySelector(
      `.bosHeaderDropdown[data-parent="${trigger.dataset.current}"]`,
    );
    if (!btn || !drop) return;
    const ul = drop.querySelector("ul");
    const btnLeft =
      btn.getBoundingClientRect().left - nav.getBoundingClientRect().left;
    ul.style.marginLeft = btnLeft + "px";
  });
}
alignDropdown();
window.addEventListener("resize", alignDropdown);
